import { render, staticRenderFns } from "./ShipmentDetailsModal.vue?vue&type=template&id=50743c62&scoped=true&"
import script from "./ShipmentDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ShipmentDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentDetailsModal.vue?vue&type=style&index=0&id=50743c62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50743c62",
  null
  
)

export default component.exports